import util from '../util'

let controller = 'OperadorFrontEndContaExcecaoHorario'
export default Object.assign({}, util.GetCrud(controller, null), {
  ObterPorContaOperador: function (dto) {
    return util.Axios.GetAll(controller + '/PorContaOperador', dto, true)
  }
})
